/**
 * 流程节点：和一下流程节点匹配为 “采购人员填写” - High/Low 表单
 */
export const purchasingStaffFillInNodeCodesForHighOrLow = [
  "24d133fa-89c4-4647-aa86-fc90ee745888",
];

/**
 * 流程节点：“采购经理审批” - Low Value
 */
export const purchaseManagerAuditNodeCodesForLow = [
  "28ef17ed-bae3-449a-aa55-306856f8efbf",
];

/**
 * 流程节点：“申请人补充/更新文件” - High 表单
 */
export const applicantAddOrUpdateFilesNodeCodesForHigh = [
  "f1e76ce7-4a85-4610-a963-089eccf4c787",
];

/**
 * 流程节点：“采购补充/更新文件” - High 表单
 */
export const purchaserAddOrUpdateFilesNodeCodesForHigh = [
  "bb33ec5b-6899-48bf-be27-cd24524f6f75",
];

/**
 * 流程节点：和以下流程节点匹配为 "采购经理填写+审核" 节点 - RD 表单
 */
export const purchaseManagerAuditNodeCodesForRD = [
  "3726d658-6900-48bd-b323-7bca58b672a7",
];

/**
 * 流程节点：和以下流程节点匹配为 "采购经理审核" 节点 - RLD 表单
 */
export const purchaseManagerAuditNodeCodesForRLD =
  purchaseManagerAuditNodeCodesForRD;

/**
 * 流程节点：和以下流程节点匹配为 "填写PO" 节点
 */
export const fillInPONodeCodes = [
  "dace2f7e-64d7-47cf-95ad-db1a144fd1a5",
  "1b512632-31d5-452e-96f9-bd7a307e3d05",
];

/** 流程节点：财务人员初审 */
export const financialFirstAuditNodeCodes = [
  "bfea9347-638d-45fb-b9b6-88c1d7cef70d",
];

/** 流程节点：上传合同 */
export const uploadContractNodeCodes = ["a69bb12e-2e5b-42e5-aafd-f267ab7fe3cf"];

/** 流程节点：财务创建固定资产编号 */
export const createFixedAssetsNoNodeCodes = [
  "df963783-5fd1-409b-bc91-318d514a004e",
];
